import { useTranslate } from "@refinedev/core";
import { InvoiceIcon, SettingsTileCard } from "@fawkes/ui";

import type { TileComponentProps } from "./types";

// Financieel — bookkeeping connection + ledger. Present in both contexts; the sub-items differ
// (organisation: connection + ledger accounts; vestiging: location-specific + bookkeeping + ledger).
// Migrated: the card opens the in-SPA Financieel detail (FinanceSettings) hosting both the "Koppeling
// boekhouding" connection box and the "Grootboeknummers" ledger list. The backing config is
// organisation-global, so both contexts open the same detail.
export const FINANCE_TILE_KEY = "finance";

const ORG_ITEM_KEYS = [
  "instellingen.item.koppelingBoekhouding",
  "instellingen.item.grootboeknummers",
];
const BRANCH_ITEM_KEYS = [
  "instellingen.item.vestigingSpecifiek",
  "instellingen.item.boekhouden",
  "instellingen.item.grootboek",
];

export function FinanceTile({ context, onOpenDetail }: TileComponentProps) {
  const t = useTranslate();
  const itemKeys = context.type === "branch" ? BRANCH_ITEM_KEYS : ORG_ITEM_KEYS;
  return (
    <SettingsTileCard
      tileKey={FINANCE_TILE_KEY}
      icon={<InvoiceIcon className="settings-tile-icon" width={16} height={16} />}
      title={t("instellingen.tile.finance.title")}
      description={t("instellingen.tile.finance.desc")}
      items={itemKeys.map((k) => t(k))}
      openLabel={t("instellingen.cta.open")}
      onOpen={() => onOpenDetail("finance")}
    />
  );
}
